import React, { useEffect, useState } from "react";
import "./site-addresses.scss";
import { Col, Container, Row } from "react-bootstrap";
import {
  Button,
  LogoHp,
  Modal,
  Select,
  Table,
  TextBox,
  useToast,
} from "@veneer/core";
import { Trans, useTranslation } from "react-i18next";
import { getCountry, getValidatedNumberInput, onSearchDropDown } from "../../../../utils";
import { apiPost } from "../../../../services/service";
import {
  validateField,
  validateForm,
} from "../../../../form-validation/form-Validation";
import { addressvalidatedcountryexclusionlst } from "../../../../resources/exclusion-country-validation";
import Loader from "../../shared-components/loader/loader";
import {
  POST_DunsNumberDropDownShippingAddres_SelectedIndexChanged,
  POST_PROFILE_PAGE_LOAD,
  POST_ACCOUNT_SAVE,
  POST_SEARCH_SAVED_ADDRESSs,
  POST_validateaddress,
} from "../../../../services";
import { toast } from "react-toastify";
import { HelpModalPopup } from "@components/home-page/shared-components/modal-popup/help-modal-popup";
import { HpLogo } from "@components/home-page/shared-components/hp-logo/hp-logo";
interface State {
  [key: string]: string;
}
interface FormStateType {
  [key: string]: any;
}
export const SiteAddresses = () => {
  const [country, setCountry] = useState<any>();
  const [countryList, setCountryList] = useState<any>();
  const [countryNameList, setCountryNameList] = useState<any>();
  const [shippingCompanyList, setShippingCompanyList] = useState<any>();
  const [defaultData, setdefaultData] = useState<any>();
  const [errorState, setErrorState] = useState<State>({});
  const [progress, setProgress] = useState(false);
  const [SearchedCountry, setSearchedCountry] = useState("");
  const [disabledAddr, setDisabledAddr] = useState<boolean>(true);
  const [modalAddress, setModalAddress] = React.useState<any>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedCountry, setSelectedCountry] = useState<string>("");
  const [contryEnable, setContryEnable] = useState<boolean>(false);
  const { addToast } = useToast();
  const [popupTilte, setPopupTitle] = useState<string>("");
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const { t } = useTranslation();
  const columns = [
      {
          id: "AddressLine1",
          label: t('HPI.CreateCase.address.AddressLine1',{defaultValue:'Address'}),
      },
      {
          id: "AddressLine2",
          label: t('HPI.CreateCase.address.AddressLine2',{defaultValue:'AddressLine2'}),
      },
      {
          id: "City",
          label: t('HPI.CreateCase.address.City/Town',{defaultValue:'City/Town'}),
      },
      {
          id: "Province",
          label: t('HPI.CreateCase.address.State/Province',{defaultValue:'State/Province'}),
      },
      {
          id: "PostalCode",
          label: t('HPI.CreateCase.address.ZipCode',{defaultValue:'Zip code/Postal code'}),
      },
      {
          id: "Country",
          label: t('HPI.MainHomePage.Country',{defaultValue:'Country'}),
      },
  ];
  const [formState, setFormState] = useState<FormStateType>({
    
    shpmailstop: "",
    address1_line1: "",
    address1_line2: "",
    address1_line3: "",
    address1_city: "",
    address1_stateorprovince: "",
    address1_postalcode: "",
    countryNameid: "",
  });
  const empytyFormState: FormStateType = {
    
    shpmailstop: "",
    address1_line1: "",
    address1_line2: "",
    address1_line3: "",
    address1_city: "",
    address1_stateorprovince: "",
    address1_postalcode: "",
    countryNameid: "",
  };
  const pageLoadFetch = async () => {
    setProgress(true);
    try {
      const payload = {
        tabid: "savedAddresses",
        
        
      };
      const response = await apiPost(POST_PROFILE_PAGE_LOAD, payload);
      if (response?.data) {
        const data = response?.data;
        const CountryList: any[] = JSON.parse(data.CountryList)
          ? [
            { label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "-1" },
            ...JSON.parse(data.CountryList).map(({ Value, Key }: any) => ({
              label: Value,
              value: Key,
            })),
          ]
          : [];
        const ShippingCompanyList: any[] = JSON.parse(data.ShippingCompanyList)
          ? [
            { label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "-1" },
            ...JSON.parse(data.ShippingCompanyList).map(
              ({ Value, Key }: any) => ({
                label: Value,
                value: Key,
              })
            ),
          ]
          : [];

        setCountry(CountryList);
        setCountryList(CountryList)
        setCountryNameList(CountryList)
        setShippingCompanyList(ShippingCompanyList);
        await DNS_number(ShippingCompanyList);
        setProgress(false);
      } else {
        setProgress(false);
        toast.error(response?.Message);
      }
    } catch (error) {
      setProgress(false);
      console.error("Error in pageLoadFetch API", error);
    }
  };
  const DNS_number = async (ShippingCompanyList: any[],defaultIndexORName =1) => {
    setProgress(true);
    try {
      const payload1 = {
        parentCustomerId: "f16eeb64-73fc-e611-80fa-5065f38ad971",
        shippingcompanyid: (defaultIndexORName ===1 )?ShippingCompanyList?.[1]?.value:defaultIndexORName,
      };
      const res = await apiPost(
        POST_DunsNumberDropDownShippingAddres_SelectedIndexChanged,
        payload1
      );
      if (res?.data) {
        const data = res?.data;
        if (data?.AccountDetails) {
          const parsedData = JSON.parse(data.AccountDetails)?.[0];
          setdefaultData(parsedData);
          setFormState((prevState) => ({
            ...prevState,
            ["shippingcompanyid"]: (defaultIndexORName ===1 )?ShippingCompanyList?.[1]?.value:defaultIndexORName,
          }));
          setProgress(false);
        }
      }
    } catch (error) {
      setProgress(false);
      console.error("Error in DNS API");
    }
  };
  useEffect(() => {
    pageLoadFetch();
  }, []);
  useEffect(() => {
    updateFormStateOnLoad(defaultData);
  }, [defaultData]);
  const updateFormStateOnLoad = (defaultData: any) => {
    setFormState((prevState: any) => ({
      ...prevState,
      ...defaultData,
      ['shpcontname']: defaultData?.shpcontname,
      ['shpcontphone']: defaultData?.shpcontphone,
      ['shpextn']: defaultData?.shpextn,
      ['shpmailstop']: defaultData?.shpmailstop,
      ['address1_line1']: defaultData?.address1_line1,
      ['address1_line2']: defaultData?.address1_line2,
      ['address1_line3']: defaultData?.address1_line3,
      ['address1_city']: defaultData?.address1_city,
      ['address1_stateorprovince']: defaultData?.address1_stateorprovince,
      ['address1_postalcode']: defaultData?.address1_postalcode,
      ['countryNameid']: defaultData?.countryNameid,
    }));
  };
  const handleChange = (v: any, e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormState((prevState: any) => ({
      ...prevState,
      [name]: v,
    }));

    if (['shpcontphone'].includes(name)) {
      setErrorState((prevState) => ({
        ...prevState,
        [name]: '',
      }));
    } else {
      validateField(name, v, setErrorState,t);
    }

  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (value) {
      validateField(name, value, setErrorState,t);
    }
  };




  const handleSelectChange = (selectedOption: any, name: any) => {
    setFormState((prevState) => ({
      ...prevState,
      [name]: selectedOption.value,
    }));
    if (name === "countryNameid") {
      setSelectedCountry(selectedOption?.label);
    }
    if (name === "Country") {
      setSearchedCountry(selectedOption?.value);
    }
    if (name === "shippingcompanyid" && selectedOption.value !== "-1") {
      DNS_number(shippingCompanyList,selectedOption.value);
    } else if (name === "shippingcompanyid" && selectedOption.value === "-1")
      setFormState(empytyFormState);
  };

  const SearchCountry = async (e: React.FormEvent) => {
    setProgress(true);
    setFormState(empytyFormState);
    try {
      let payload: any = {
        
        
        selectedCountry: SearchedCountry,
      };
      if (formState.givenState && formState.givenState !== "") {
        payload.givenState = formState.givenState;
      }
      let savedata = await apiPost(POST_SEARCH_SAVED_ADDRESSs, payload);
      let data = savedata?.data;
      const ShippingCompanyLists: any[] = JSON.parse(data.ShippingCompanyList)
        ? [
          { label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "-1" },
          ...JSON.parse(data.ShippingCompanyList).map(
            ({ Value, Key }: any) => ({
              label: Value,
              value: Key,
            })
          ),
        ]
        : [];
      setShippingCompanyList(ShippingCompanyLists);
      setProgress(false);
    } catch (error) { }
  };
  const handleRowItemClick = (data: any) => {
    setFormState({
      address1_city: data.City,
      address1_line1: data.AddressLine1,
      address1_line2: data.AddressLine2,
      address1_postalcode: data.PostalCode,
      address1_stateorprovince: data.Province,
      countryNameid: formState["countryNameid"],
    });
    setOpen(false);
  };
  const clickAbleRowItems = (data: any, items: any) => {
    return (
      <button
        onClick={() => {
          handleRowItemClick(data);
        }}
      >
        {items}
      </button>
    );
  };

  const popupHeader = () => {
    return (
      <p className="popup-header">
        <img
          src="https://logos-world.net/wp-content/uploads/2020/11/HP-Logo.png"
          alt=""
          style={{ height: "46px", width: "auto" }}
        />
        <span>{popupTilte}</span>
      </p>
    );
  };

  const handleCallBack = (title: string) => {
    setPopupTitle(title);
    setOpenPopup(true);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    let FormErrors = validateForm(formState, "saveAddress",t);
    setErrorState(FormErrors);
    if (Object.keys(FormErrors).length > 0) {
      toast.error(t('HPI.ErrorMessage.FillRequiredFields',{defaultValue:'Please fill the required fields'}));
    } else {
      setProgress(true);
      let payload = {
        ...formState,
        
        
      };
      try {
        let savedata = await apiPost(POST_ACCOUNT_SAVE, payload);
        if (savedata.data) {
          toast.success(savedata?.data?.successmessage);
          setProgress(false);
          pageLoadFetch();
        } else {
          setProgress(false);
        }
      } catch (error) {
        setProgress(false);
      }
    }
  };
  const validateAddress = async () => {
    setProgress(true);

    try {
      setDisabledAddr(true);
      let payload = {
        country: selectedCountry,
        phZipcode: formState?.["address1_postalcode"],
        phState: formState?.["address1_stateorprovince"],
        phCity: formState?.["address1_city"],
        addressline1: formState?.["address1_line1"],
        
        
      };
      try {
        const getAddress: any = await apiPost(POST_validateaddress, payload);
        if (getAddress.data) {
          let addresonchange = JSON.parse(getAddress.data.AddressDoctorResult);
          let newAdd = addresonchange.map((items: any) => ({
            ...items,
            AddressLine1: clickAbleRowItems(items, items.AddressLine1),
            AddressLine2: clickAbleRowItems(items, items.AddressLine2),
            Country: clickAbleRowItems(items, items.Country),
            PostalCode: clickAbleRowItems(items, items.PostalCode),
            City: clickAbleRowItems(items, items.City),
          }));
          setModalAddress(newAdd);
          setOpen(true);
          setDisabledAddr(false);
          setProgress(false);
        }
      } catch (error) {
        setDisabledAddr(false);
        console.log("Error", error);
      }
    } catch (error) {
      addToast({
        text: `${error}`,
        type: "warning",
        timeout: 15,
        id: 1,
      });
      return false;
      // console.log("error", error);
    }
  };
  return (
    <div className="site-addresses">
      {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}
      <h3>
        {t("HPI.Profilepage.CreateContacts.saveaddress.ShippingAddress", {
          defaultValue: "Shipping address:",
        })}
        <span>
          {t("HPI.Profilepage.CreateContacts.saveaddress.NameChangeHelp", {
            defaultValue:
              "If you require a name change of site address then please contact HP support",
          })}
        </span>
      </h3>

      <form className="site-address-form">
        <Container>
          <Row>
            <Col col={6} md={4}>
              <Select
                separateLabel
                showSearch
                options={countryList ? countryList : []}
                label={t(
                  "HPI.Profilepage.CreateContacts.saveaddress.CountryRegion",
                  { defaultValue: "Country" }
                )}
                placement="bottom"
                placeholder={t("HPI.ProfilePage.cs.SelectCountry", {
                  defaultValue: "Select Country/Region",
                })}
                onSearch={(value: any) => {
                  let filtered: any = onSearchDropDown(country, value);
                  setCountryList(filtered);
                }}
                className="textbox"
                helperTextVisibility="auto"
                name="Country"
                onChange={(selectedOption: any) => {
                  handleSelectChange(selectedOption, "Country");
                }}
              />
            </Col>
            <Col col={6} md={4}>
              <TextBox
                defaultValue=""
                label={t(
                  "HPI.Profilepage.CreateContacts.saveaddress.StateProvince",
                  { defaultValue: "State/Province" }
                )}
                placeholder={t('HPI.Profilepage.Placeholder.EnterState/Province',{defaultValue:'Enter state/province'})}
                className="textbox"
                name="givenState"
                separateLabel
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
              />
            </Col>

            <Col col={6} md={4}>
              <Button className="search-button" onClick={SearchCountry}>
                {t("HPI.Profilepage.CreateContacts.saveaddress.Search", {
                  defaultValue: "Search",
                })}
              </Button>
            </Col>
          </Row>

          <Row>
            <Col col={12} md={4} className="input-container">
              <div className="tooltip-container">
                <div className="label-container ">
                  <label>
                    {t(
                      "HPI.Profilepage.CreateContacts.saveaddress.Companyname",
                      { defaultValue: "Site Name" }
                    )}
                  </label>
                  <span className="supporting-text">
                    <HelpModalPopup
                      align={"start"}
                      id={"modal-popup"}
                      show={openPopup}
                      onClose={() => setOpenPopup(false)}
                      title={popupHeader()}
                      callback={() => handleCallBack(t("HPI.ProfilePage.EmailTooltip.Header",{defaultValue:'Email Address'}))}
                    >
                      <p>
                      {t("HPI.ProfilePage.EmailTooltip.Content", {defaultValue:"This field is locked and can only be modified through a support request to HP. See the MyHPSupport Help page for instructions on submitting a support request."})}
                      </p>
                    </HelpModalPopup>
                  </span>
                </div>
                <Select
                  separateLabel
                  options={shippingCompanyList ? shippingCompanyList : []}
                  // label={t(
                  //   "HPI.Profilepage.CreateContacts.saveaddress.Companyname",
                  //   { defaultValue: "Site Name" }
                  // )}
                  placement="bottom"
                  className="textbox"
                  helperTextVisibility="auto"
                  name="shippingcompanyid"
                  clearIcon={false}
                  onChange={(selectedOption: any) => {
                    handleSelectChange(selectedOption, "shippingcompanyid");
                  }}
                  value={[formState?.["shippingcompanyid"]]}
                />
              </div>
            </Col>
          </Row>
          
          <Row>
            <Col col={12} md={4}>
              <TextBox
                label={t(
                  "HPI.Profilepage.CreateContacts.saveaddress.Mailstop",
                  { defaultValue: "Mail stop" }
                )}
                placeholder={t('HPI.Profilepage.Placeholder.EnterMailStop',{defaultValue:'Enter mail stop'})}
                className="textbox"
                separateLabel
                name="shpmailstop"
                value={formState["shpmailstop"]}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col col={12} md={4}>
              <TextBox
                label={t(
                  "HPI.Profilepage.CreateContacts.saveaddress.Addressline1",
                  { defaultValue: "Address line 1" }
                )}
                placeholder={t('HPI.Profilepage.Placeholder.EnterAddressLine1',{defaultValue:'Enter address line 1'})}
                className="textbox"
                separateLabel
                name="address1_line1"
                required
                value={formState["address1_line1"]}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
                error={errorState["address1_line1"] ? true : false}
                helperText={errorState["address1_line1"] || ""}
              />
            </Col>

            <Col col={12} md={4}>
              <TextBox
                label={t(
                  "HPI.Profilepage.CreateContacts.saveaddress.Addressline2",
                  { defaultValue: "Address line 2" }
                )}
                placeholder={t('HPI.Profilepage.Placeholder.EnterAddressLine2',{defaultValue:'Enter address line 2'})}
                className="textbox"
                name="address1_line2"
                separateLabel
                value={formState?.["address1_line2"]}
                onChange={(v: any, e: any) => {
                  handleChange(v, e);
                  if(v === ""){
                    setErrorState((prevState) => ({
                      ...prevState,
                      ["address1_line2"]: '',
                    }));
                  }
                }}
                error={errorState["address1_line2"] ? true : false}
                helperText={errorState["address1_line2"] || ""}
              />
            </Col>

            <Col col={12} md={4}>
              <TextBox
                label={t(
                  "HPI.Profilepage.CreateContacts.saveaddress.Addressline3",
                  { defaultValue: "Address line 3" }
                )}
                placeholder={t('HPI.Profilepage.Placeholder.EnterAddressLine3',{defaultValue:'Enter address line 3'})}
                name="address1_line3"
                className="textbox"
                separateLabel
                value={formState?.["address1_line3"]}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                  setErrorState((prevState) => ({
                    ...prevState,
                    ["address1_line3"]: '',
                  }));
                }}
                error={errorState["address1_line3"] ? true : false}
                helperText={errorState["address1_line3"] || ""}
              />
            </Col>
          </Row>

          <Row>
            <Col col={12} md={4}>
              <TextBox
                label={t(
                  "HPI.Profilepage.CreateContacts.saveaddress.CityTown",
                  { defaultValue: "City/Town" }
                )}
                placeholder={t('HPI.Profilepage.Placeholder.EnterCity/Town',{defaultValue:'Enter city/town'})}
                name="address1_city"
                className="textbox"
                separateLabel
                required
                value={formState?.["address1_city"]}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
                error={errorState["address1_city"] ? true : false}
                helperText={errorState["address1_city"] || ""}
              />
            </Col>

            <Col col={12} md={4}>
              <TextBox
                label={t(
                  "HPI.Profilepage.CreateContacts.saveaddress.StateProvince",
                  { defaultValue: "State/Province" }
                )}
                placeholder={t('HPI.Profilepage.Placeholder.EnterState/Province',{defaultValue:'Enter state/province'})}
                name="address1_stateorprovince"
                className="textbox"
                separateLabel
                required
                value={formState?.["address1_stateorprovince"]}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
                error={errorState["address1_stateorprovince"] ? true : false}
                helperText={errorState["address1_stateorprovince"] || ""}
              />
            </Col>

            <Col col={12} md={4}>
              <TextBox
                label={t(
                  "HPI.Profilepage.CreateContacts.saveaddress.ZipCodePostalCode",
                  { defaultValue: "Zip code/Postal code" }
                )}
                name="address1_postalcode"
                placeholder={t('HPI.Profilepage.Placeholder.EnterZip/PostalCode',{defaultValue:'Enter zip/postal code'})}
                className="textbox"
                separateLabel
                required
                error={errorState["address1_postalcode"] ? true : false}
                helperText={errorState["address1_postalcode"] || ""}
                value={formState?.["address1_postalcode"]}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col col={12} md={4}>
              <Select
                name="countryNameid"
                options={countryNameList ? countryNameList : []}
                label={t("HPI.ProfilePage.cs.SelectCountry", {
                  defaultValue: "Select country/Region",
                })}
                placeholder={t("HPI.ProfilePage.cs.SelectCountry", {
                  defaultValue: "Select country/Region",
                })}
                className="textbox"
                separateLabel
                error={errorState["countryNameid"] ? true : false}
                helperText={errorState["countryNameid"] || ""}
                required
                
                onChange={(selectedOption: any) => {
                  handleSelectChange(selectedOption, "countryNameid");
                  if (selectedOption?.value) {
                    setContryEnable(false);
                    if (
                      !addressvalidatedcountryexclusionlst.includes(
                        selectedOption.label.toLowerCase()
                      )
                    ) {
                      setContryEnable(true);
                    }
                    setErrorState((errors: any) => ({
                      ...errors,
                      partshipigcountry: "",
                    }));
                  }
                }}
                
                showSearch
                onSearch={(value: any) => {
                  let filtered: any = onSearchDropDown(country, value);
                  setCountryNameList(filtered);
                }}
                value={[formState?.["countryNameid"]]}
                //clearIcon={false} 
                onClear={() => {
                  setFormState((prevState: any) => ({
                      ...prevState,
                      ["countryNameid"]: "",
                    }));
                } }
              />
            </Col>
            <Col col={12} md={3}>
              <Button className="search-button" onClick={handleSubmit}>
                {t("HPI.Save", { defaultValue: "Save" })}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col col={12} md={3}>
              {contryEnable ? (
                <Button className="search-button" onClick={validateAddress}>
                  Validate Address
                </Button>
              ) : (
                ""
              )}
              <Modal
                className="validate-address-modal"
                closeButton
                id="modal-id"
                show={open}
                onClose={() => setOpen(false)}
                header={
                  <div className="row">
                    <Col>
                      <HpLogo />
                    </Col>
                    <Col>
                      <h3>{t('HPI.Profilepage.myprofile.Address',{defaultValue:'Address'})}</h3>
                    </Col>
                  </div>
                }
              >
                <Table columns={columns} data={modalAddress} />
              </Modal>
            </Col>
          </Row>
        </Container>
      </form>
    </div>
  );
};
